const SWIPE_MIN = 60;

export default {
  // A horizontal swipe on the stage turns the page. Only for touch: a mouse
  // drag is a selection, and the edge zones already take a click.
  handlePointerDown(event) {
    if (event.pointerType !== "touch" || this.overview || this.stacked) return;
    this.swipe = { x: event.clientX, y: event.clientY };
  },

  handlePointerUp(event) {
    if (!this.swipe || event.pointerType !== "touch") return;
    const dx = event.clientX - this.swipe.x;
    const dy = event.clientY - this.swipe.y;
    this.swipe = null;
    if (Math.abs(dx) < SWIPE_MIN || Math.abs(dy) > Math.abs(dx)) return;
    if (dx < 0) this.next();
    else this.previous();
  },
};
